import { render, staticRenderFns } from "./VeHrHetongForm.vue?vue&type=template&id=33ac4240"
import script from "./VeHrHetongForm.vue?vue&type=script&lang=js"
export * from "./VeHrHetongForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports